<template>
  <div>
    <LicenseRecord ref="licenseRecord" :vehicleInfo="vehicleInfo" />
    <InsuranceRecord ref="lnsuranceRecord" :vehicleInfo="vehicleInfo" />
    <AccidentRecords ref="accidentRecords" />
    <MaintenanceRecords ref="maintenanceRecords"/>
  </div>
</template>

<script>
import LicenseRecord from './licenseRecord/licenseRecord';
import InsuranceRecord from './insuranceRecord/insuranceRecord';
import AccidentRecords from './accidentRecords/accidentRecords';
import MaintenanceRecords from './maintenanceRecords/maintenanceRecords';
export default {
  components: {
    MaintenanceRecords,
    LicenseRecord,
    InsuranceRecord,
    AccidentRecords,
  },
  data () {
    return {
      vehicleInfo: {},
    };
  },
  methods: {
    getData () {
      this.$refs.licenseRecord.getData();
      this.$refs.lnsuranceRecord.getData();
      this.$refs.accidentRecords.getData();
      this.$refs.maintenanceRecords.getData();
    },
    setVehicleInfo (vehicleInfo) {
      this.vehicleInfo = vehicleInfo;
    },
  },
};
</script>

<style>
</style>
